import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ECurrencyToSymbolPipe } from 'projects/shared/lib/pipes/currency/symbol/ecurrency-to-symbol.pipe';
import { ICartService, ICartServiceToken } from 'projects/shared/lib/services/data/cart/cart-service.interface';
import { ECurrency, EShoppingCartValidationError, ShoppingCartValidationResultDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { Subscription, tap } from 'rxjs';

@Component({
  selector: 'app-cart-validation-result-cart',
  imports: [
    CommonModule,
    ECurrencyToSymbolPipe
  ],
  templateUrl: './cart-validation-result-cart.component.html',
  styleUrls: ['./cart-validation-result-cart.component.scss']
})
export class CartValidationResultCartComponent implements OnInit, OnDestroy {

  private readonly cartDataService: ICartService;

  private cartValidationSubscription?: Subscription | undefined;

  @Input() public shouldDisplayValidResult?: boolean | undefined;

  public eCartValidationError: typeof EShoppingCartValidationError = EShoppingCartValidationError;
  public eCurrency: typeof ECurrency = ECurrency;

  public cartValidationResult: ShoppingCartValidationResultDto | undefined;
  public hasItemValidationErrors: boolean | undefined;

  public constructor() {
    this.cartDataService = inject(ICartServiceToken);
  }

  public ngOnInit(): void {
    this.cartValidationSubscriptionInit();
  }

  public ngOnDestroy(): void {
    this.cartValidationSubscription?.unsubscribe();
  }

  private cartValidationSubscriptionInit() {
    if (this.cartValidationSubscription != undefined) {
      return;
    }

    this.cartValidationSubscription = this.cartDataService.cartValidationChangedGet().pipe(
      tap(
        (cartValidationResult) => {
          this.cartValidationResult = cartValidationResult;
          this.hasItemValidationErrors = this.cartValidationResult?.itemValidationErrorList != undefined && this.cartValidationResult.itemValidationErrorList.length > 0;
        }
      )
    ).subscribe();
  }

}
